import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_loggedin_user_meta_data_action,
  get_all_added_skills_hiring_manager_action,
  get_suggested_mentors_hiring_manager_action,
  get_suggested_candidates_hiring_manager_action,
  get_all_assessment_kits_data_action,
} from "../../../redux/_actions";
import { appRoutes } from "../../../_routes/app-routes";

function useHiringManagerDashboar(props) {
  const [companyName, setCompanyName] = useState({});
  const [skillsListLoading, setSkillsListLoading] = useState(false);
  const [skillsTagsAdded, setSkillsTagsAdded] = useState();
  const [suggestedMentorsLoading, setSuggestedMentorsLoading] = useState(false);
  const [suggestedMentors, setSuggestedMentors] = useState([]);
  const [suggestedCandidatesLoading, setSuggestedCandidatesLoading] =
    useState(false);
  const [suggestedCandidates, setSuggestedCandidates] = useState([]);
  const [mentorSelectedSkill, setMentorSelectedSkill] = useState();
  const [candidateSelectedSkill, setCandidateSelectedSkill] = useState();
  const [assessmentKits, setAssessmentKits] = useState([]);
  const [assesmentKitsLoading, setAssessmentKitsLoading] = useState(false);


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loggedInMetaData } = useSelector(
    (state) => state.get_loggedin_user_meta_data_reducer
  );
  const { allAddedSkillsData } = useSelector(
    (state) => state.get_all_added_skills_hiring_manager_reducer
  );
  const { suggestedMentorsData } = useSelector(
    (state) => state.get_suggested_mentors_hiring_manager_reducer
  );
  const { suggestedCandidatesData } = useSelector(
    (state) => state.get_suggested_candidates_hiring_manager_reducer
  );

  const { allPublishedAssessmentData } = useSelector(
    (state) => state.get_all_assessment_kits_data_reducer
  );


  useEffect(() => {
    getProfileApi();
    callSkillsApi();
    getAssessmentKits("publish");
  }, []);

  useEffect(() => {
    if (allPublishedAssessmentData) {
      setAssessmentKits(allPublishedAssessmentData);
    }
  }, [allPublishedAssessmentData]);

  useEffect(() => {
    if (allAddedSkillsData?.data) {
      let data = allAddedSkillsData.data?.results;
      let results =
        Array.isArray(data) &&
        data.map((item) => {
          return item.skill;
        });
      if (results && results.length > 0) {
        getSuggestedMentorsApi(results);
        getSuggestedCandidatesApi(results);
      }
    }
  }, [allAddedSkillsData]);

  useEffect(() => {
    if (loggedInMetaData?.data) {
      setCompanyName(loggedInMetaData?.data);
    }
  }, [loggedInMetaData]);

  useEffect(() => {
    if (allAddedSkillsData?.data) {
      setSkillsTagsAdded(allAddedSkillsData.data?.results);
    }
  }, [allAddedSkillsData]);
  useEffect(() => {
    if (suggestedMentorsData?.data) {
      let results = suggestedMentorsData?.data;
      setSuggestedMentors(results);
    }
  }, [suggestedMentorsData]);
  useEffect(() => {
    if (suggestedCandidatesData?.data) {
      let results = suggestedCandidatesData?.data;
      setSuggestedCandidates(results);
    }
  }, [suggestedCandidatesData]);

  const getAssessmentKits = async (type) => {
    setAssessmentKitsLoading(true);
    await dispatch(get_all_assessment_kits_data_action(type));
    setAssessmentKitsLoading(false);
  };

  const getProfileApi = async () => {
    await dispatch(get_loggedin_user_meta_data_action());
  };

  const callSkillsApi = async () => {
    setSkillsListLoading(true);
    await dispatch(get_all_added_skills_hiring_manager_action());
    setSkillsListLoading(false);
  };

  const getSuggestedMentorsApi = async (skills) => {
    setSuggestedMentorsLoading(true);
    await dispatch(
      get_suggested_mentors_hiring_manager_action({ skills: skills })
    );
    setSuggestedMentorsLoading(false);
  };

  const getSuggestedCandidatesApi = async (skills) => {
    setSuggestedCandidatesLoading(true);
    await dispatch(
      get_suggested_candidates_hiring_manager_action({ skills: skills })
    );
    setSuggestedCandidatesLoading(false);
  };

  const onMentorJobsSkillsChange = (skill) => {
    setMentorSelectedSkill(skill);
    let data = [];
    data.push(skill.skill);
    getSuggestedMentorsApi(data);
  };

  const onCandidatesJobsSkillsChange = (skill) => {
    setCandidateSelectedSkill(skill);
    let data = [];
    data.push(skill.skill);
    getSuggestedCandidatesApi(data);
  };

  const onViewMentorProfileClick = (id) => {
    if (id) navigate(`/mentor-profile/${id}`, { state: id });
  };

  const onViewCandidateProfileClick = (id) => {
    if (id) navigate(`/view-candidate-profile/${id}`, { state: id });
  };

  const onCandidateSkillUnselectClick = () => {
    setCandidateSelectedSkill(null);
    if (allAddedSkillsData?.data) {
      let data = allAddedSkillsData.data?.results;
      let results = Array.isArray(data) && data.map((item) => {
        return item.skill;
      });
      if (results && results.length > 0) {
        getSuggestedCandidatesApi(results);
      }
    }
  };
  const onMentorSkillUnselectClick = () => {
    setMentorSelectedSkill(null);
    if (allAddedSkillsData?.data) {
      let data = allAddedSkillsData.data?.results;
      let results =
        Array.isArray(data) &&
        data.map((item) => {
          return item.skill;
        });
      if (results && results.length > 0) {
        getSuggestedMentorsApi(results);
      }
    }
  };

  const onViewAllMentorsClick = () => {
    navigate(`/all-mentors`);
  };

  const onViewAllCandidatesClick = () => {
    navigate(`/all-candidates`);
  };

  const onViewAssessmentsClick = () => {
    navigate(appRoutes.assessementKit.allAssessments);
  };

  const onViewCandidatesClick = (interviewKit) => {
    navigate(appRoutes.assessementKit.viewCandidates.replace(":id" ,interviewKit));
  };

  const onEditKitClick = (id) => {
    navigate(appRoutes.assessementKit.viewAssessment.replace(":id", id));
  };

  const onClickNewAssessment = () => {
    navigate(appRoutes.assessementKit.createAssessment);
  };

  return {
    assesmentKitsLoading,
    assessmentKits,
    companyName,
    skillsListLoading,
    skillsTagsAdded,
    mentorSelectedSkill,
    candidateSelectedSkill,
    suggestedMentorsLoading,
    suggestedMentors,
    suggestedCandidates,
    suggestedCandidatesLoading,
    onViewMentorProfileClick,
    onMentorJobsSkillsChange,
    onCandidatesJobsSkillsChange,
    onViewCandidateProfileClick,
    onMentorSkillUnselectClick,
    onCandidateSkillUnselectClick,
    onViewAllMentorsClick,
    onViewAllCandidatesClick,
    onViewAssessmentsClick,
    onViewCandidatesClick,
    onEditKitClick,
    onClickNewAssessment
  };
}
export default useHiringManagerDashboar;
